import StudyListExpandedRow from './StudyListExpandedRow';
export default StudyListExpandedRow;
